/**
 * @generated SignedSource<<c8597244aa408f52c4058d3fedc92c36>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchConfluenceSpace_AtlassianSearchPage$data = {
  readonly __typename: "SearchConfluenceSpace";
  readonly description: string;
  readonly iconUrl?: string | null | undefined;
  readonly id: string;
  readonly lastModified: string | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchConfluenceSpace_AtlassianSearchPage";
};
export type searchConfluenceSpace_AtlassianSearchPage$key = {
  readonly " $data"?: searchConfluenceSpace_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchConfluenceSpace_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    }
  ],
  "kind": "Fragment",
  "name": "searchConfluenceSpace_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "condition": "includeIconUrl",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModified"
    }
  ],
  "type": "SearchConfluenceSpace"
};

(node as any).hash = "0c267c1ef1d1bacf6c1b9971a73d0911";

export default node;
